<template>
    <div class="postcode-wrapper">
        <input type="text" v-bind:class="classes" v-bind:id="id" :name="name" v-model="postcode" :placeholder="placeholder"/>

        <small v-show="status === 'in_progress'"><i class='fa fa-spin fa-spinner'></i> Checking postcode</small>
        <small v-show="status === 'success'"><i class='fa fa-check text-success'></i> Valid postcode</small>
        <small v-show="status === 'error'"><i class='fa fa-info-circle text-warning'></i> The postcode could not be identified, your location will be estimated. Please fill in the exact address.</small>
    </div>
</template>

<script>
import _ from 'lodash';
    export default {
        props: ['name', 'modelValue', 'id', 'classes', 'placeholder'],

        data() {
            return {
                postcode: "",
                status: "stand-by",
            };
        },

        watch: {
            postcode: function (val, oldVal) {
                this.$emit('update:modelValue', val);

                if (!val || val.length < 4) {
                    this.emitEvent({latitude: null, longitude: null});

                    return;
                }

                this.getCoordinates();
            }
        },

        mounted() {
            let unwatch = this.$watch('modelValue', () => {
                this.postcode = this.modelValue;
                unwatch();
            })
        },

        methods: {
            getCoordinates: _.debounce(function () {
                let vm = this;
                vm.status = "in_progress";

                window.axios.get(`/api/postal_codes/${vm.postcode.toUpperCase()}`)
                    .then((response) => {
                        vm.status = "success";
                        vm.emitEvent({
                            latitude: response.data.result.latitude,
                            longitude: response.data.result.longitude,
                        });
                    }).catch(() => {
                        vm.status = "error";
                        vm.emitEvent({latitude: null, longitude: null});
                    });

            }, 500),

            emitEvent(payload) {
                this.$emit('update:coordinates', payload);
            },
        }
    }
</script>
